import { render, staticRenderFns } from "./TimeslotPlanifGrid.vue?vue&type=template&id=35f3d954&scoped=true&"
import script from "./TimeslotPlanifGrid.vue?vue&type=script&lang=js&"
export * from "./TimeslotPlanifGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3d954",
  null
  
)

/* custom blocks */
import block0 from "./TimeslotPlanifGrid.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports